import React from "react";
import styled from "styled-components";
import { useSearchFilterOption } from "./filterContext";

const SearchFilterOption = (props: Props) => {
  const { name, value, children, single, nested } = props;

  const id = `${name}-${value}`;

  const { checked, onChange } = useSearchFilterOption({
    name,
    value,
    single,
  });

  return (
    <Label htmlFor={id} nested={nested}>
      <Checkbox
        id={id}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
      />{" "}
      {children}
    </Label>
  );
};

const Label = styled.label<{ nested: boolean }>`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-right: 1.5rem;
  padding-left: ${({ nested }) => (nested ? "3rem" : "2.5rem")};
  margin: 0;
  white-space: normal;

  :hover {
    background-color: ${({ theme }) => theme?.colors?.gray100};
  }
`;

const Checkbox = styled.input`
  &&& {
    margin: 0;
    margin-right: 0.5rem;
  }
`;

type Props = {
  name: string;
  value: string | string[] | null;
  children: string;
  nested?: boolean;
  single?: boolean;
};

export default SearchFilterOption;
